function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { useState } from 'react';
import { StoreWrapper as LegacyStoreWrapper } from '@applyboard/ab-common';
import { LegacyApplicationDataLoader, LegacyInitialPropsContext, LegacyStudentRecords, LegacyCustomFieldsTab, LegacyCustomFieldsTabBar, legacyGetTemplateString } from '@applyboard/ab-application-legacy';
import { ApplicationPageTracker } from "./components/ApplicationPageTracker";
import { useParams, useRouteMatch } from 'react-router-dom';
import { SideBarCard, SidebarProvider } from "./components/SideBar";
import { useApplication, useApplicationAvailableActions, useApplicationPageInitialProps, useFeatureFlags } from "./data";
import { assert } from "../../utils/assert";
import { Box, Card, Flex, Tabs } from '@applyboard/crystal-ui';
import { ApplicationStepperCard } from "./components/ApplicationStepper";
import { RequirementList } from "./components/RequirementList";
import { MAX_PAGE_WIDTH, GLOBAL_TOP_BAR_HEIGHT, MINI_HEADER_HEIGHT, GUTTER_WIDTH_TOKEN } from "./consts";
import { HeaderProvider } from "./components/Header";
import { match } from 'ts-pattern';
import { NotesList } from "./components/NotesList";
import { ApplicationActionName } from "../../types";
import { useNotes } from "./data/notes";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var SIDEBAR_MARGIN = GUTTER_WIDTH_TOKEN * 4;
var SIDEBAR_BORDER = 1;
var SIDEBAR_MAX_HEIGHT = "calc(100vh - ".concat(GLOBAL_TOP_BAR_HEIGHT, "px - ").concat(MINI_HEADER_HEIGHT, "px - ").concat(SIDEBAR_MARGIN * 2, "px - ").concat(SIDEBAR_BORDER * 2, "px)");
var SIDEBAR_TOP = GLOBAL_TOP_BAR_HEIGHT + MINI_HEADER_HEIGHT + SIDEBAR_MARGIN;
var STEPPER_MAX_HEIGHT = "calc(100vh - ".concat(GLOBAL_TOP_BAR_HEIGHT, "px - ").concat(MINI_HEADER_HEIGHT, "px - ").concat(SIDEBAR_MARGIN * 2, "px - ").concat(SIDEBAR_BORDER * 2, "px)");
export function StudentApplicationPageLayout(_ref) {
  var header = _ref.header,
    sidebar = _ref.sidebar,
    showNotesTakeActionMenu = _ref.showNotesTakeActionMenu,
    onStartLiveChat = _ref.onStartLiveChat;
  var _useParams = useParams(),
    requirementId = _useParams.requirement_id;
  var _useState = useState(!requirementId),
    _useState2 = _slicedToArray(_useState, 2),
    isSidebarOpen = _useState2[0],
    setIsSidebarOpen = _useState2[1];
  var _useApplicationPageIn = useApplicationPageInitialProps(),
    initialProps = _useApplicationPageIn.initialProps;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  assert(initialProps);
  var tab = useCurrentTab();
  var checkCanCreateBulkNote = useCanCreateBulkNote();
  var _useNotes = useNotes('application_customer_note'),
    customerNotes = _useNotes.applicationNotes;
  var _useNotes2 = useNotes('application_admin_note'),
    adminNotes = _useNotes2.applicationNotes;
  var numCustomerNotes = customerNotes.length;
  var numAdminNotes = adminNotes.length;
  return _jsx(SidebarProvider, {
    isOpen: isSidebarOpen,
    onOpenChange: setIsSidebarOpen,
    children: _jsx(ApplicationPageTracker, {
      applicationId: application.legacyId,
      children: _jsx(LegacyStoreWrapper, {
        children: _jsx(LegacyInitialPropsContext.Provider, {
          value: initialProps,
          children: _jsxs(LegacyApplicationDataLoader, {
            applicationId: application.legacyId,
            permissions: initialProps.permissions,
            children: [_jsx(HeaderProvider, {
              sidebar: sidebar,
              children: header
            }), _jsx("div", {
              css: function css(theme) {
                return {
                  width: '100%',
                  paddingLeft: theme.spacing[GUTTER_WIDTH_TOKEN],
                  paddingRight: theme.spacing[GUTTER_WIDTH_TOKEN],
                  paddingTop: theme.spacing[GUTTER_WIDTH_TOKEN],
                  maxWidth: MAX_PAGE_WIDTH,
                  margin: 'auto'
                };
              },
              children: _jsxs(Flex, {
                direction: "row",
                gap: GUTTER_WIDTH_TOKEN,
                children: [sidebar && _jsx(Flex.Item, {
                  grow: 0,
                  hideBelow: "md",
                  children: _jsx("div", {
                    style: {
                      position: 'sticky',
                      top: SIDEBAR_TOP
                    },
                    children: _jsx(SideBarCard, {
                      maxHeight: SIDEBAR_MAX_HEIGHT,
                      children: sidebar
                    })
                  })
                }), _jsx(Flex.Item, {
                  grow: 1,
                  shrink: 1,
                  basis: 0,
                  minWidth: 0,
                  children: _jsx(Card, {
                    children: _jsx(Box, {
                      px: 2,
                      children: _jsxs(Tabs, {
                        value: tab,
                        children: [_jsx(Tabs.Item, {
                          label: "Requirements",
                          value: "requirements",
                          href: "/applications/".concat(application.legacyId),
                          children: _jsx(RequirementList, {
                            requirementClassifications: ['applicant_requirement']
                          })
                        }), initialProps.permissions.show_actions_tab && _jsx(Tabs.Item, {
                          label: "Admin requirements",
                          value: "admin-requirements",
                          href: "/applications/".concat(application.legacyId, "/admin-requirements"),
                          children: _jsx(RequirementList, {
                            requirementClassifications: ['action_requirement', 'school_requirement']
                          })
                        }), initialProps.permissions.view_student_records && _jsx(Tabs.Item, {
                          label: "Student records",
                          value: "student-records",
                          href: "/applications/".concat(application.legacyId, "/student-records"),
                          children: _jsx(LegacyStudentRecords, {})
                        }), initialProps.permissions.index_public_note && _jsxs(Tabs.Item, {
                          label: "Notes".concat(numCustomerNotes > 0 ? " (".concat(numCustomerNotes, ")") : ''),
                          value: "notes",
                          href: "/applications/".concat(application.legacyId, "/notes"),
                          children: [_jsx(NotesList, {
                            noteType: "customer",
                            showNotesTakeActionMenu: showNotesTakeActionMenu,
                            onPrefillTemplate: function onPrefillTemplate(isPrivate, trackEvent) {
                              return legacyGetTemplateString(isPrivate, trackEvent, checkCanCreateBulkNote, true);
                            },
                            onStartLiveChat: onStartLiveChat
                          }), _jsx("div", {
                            id: "note-templates-modal-container"
                          })]
                        }), initialProps.permissions.index_private_note && _jsxs(Tabs.Item, {
                          label: "Admin comments".concat(numAdminNotes > 0 ? " (".concat(numAdminNotes, ")") : ''),
                          value: "admin-comments",
                          href: "/applications/".concat(application.legacyId, "/admin-comments"),
                          children: [_jsx(NotesList, {
                            noteType: "admin",
                            showNotesTakeActionMenu: showNotesTakeActionMenu,
                            onPrefillTemplate: function onPrefillTemplate(isPrivate, trackEvent) {
                              return legacyGetTemplateString(isPrivate, trackEvent, checkCanCreateBulkNote, true);
                            },
                            onStartLiveChat: onStartLiveChat
                          }), _jsx("div", {
                            id: "note-templates-modal-container"
                          })]
                        }), (initialProps.permissions.show_custom_field_student || initialProps.permissions.show_custom_field_application) && _jsxs(Tabs.Item, {
                          label: "Application details",
                          value: "application-details",
                          href: "/applications/".concat(application.legacyId, "/application-details"),
                          children: [(initialProps.permissions.create_custom_field_student || initialProps.permissions.create_custom_field_application) && _jsx(LegacyCustomFieldsTabBar, {
                            enableAddCustomFields: true
                          }), _jsx(LegacyCustomFieldsTab, {})]
                        })]
                      })
                    })
                  })
                }), !requirementId && _jsx(Flex.Item, {
                  grow: 0,
                  hideBelow: "lg",
                  children: _jsx("div", {
                    style: {
                      position: 'sticky',
                      top: SIDEBAR_TOP
                    },
                    children: _jsx(ApplicationStepperCard, {
                      maxHeight: STEPPER_MAX_HEIGHT
                    })
                  })
                })]
              })
            })]
          })
        })
      })
    })
  });
}
function useCurrentTab() {
  var routeMatch = useRouteMatch(['/applications/:application_id/admin-requirements', '/applications/:application_id/notes', '/applications/:application_id/admin-comments', '/applications/:application_id/student-records', '/applications/:application_id/application-details']);
  return match(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.path)["with"]('/applications/:application_id/admin-requirements', function () {
    return 'admin-requirements';
  })["with"]('/applications/:application_id/notes', function () {
    return 'notes';
  })["with"]('/applications/:application_id/admin-comments', function () {
    return 'admin-comments';
  })["with"]('/applications/:application_id/student-records', function () {
    return 'student-records';
  })["with"]('/applications/:application_id/application-details', function () {
    return 'application-details';
  }).otherwise(function () {
    return 'requirements';
  });
}
export function useCanCreateBulkNote() {
  var _useFeatureFlags = useFeatureFlags(),
    featureFlags = _useFeatureFlags.featureFlags;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila.getApplicationAvailableAction;
  var adminCreateNoteAction = getApplicationAvailableAction(ApplicationActionName.CREATE_ADMIN_NOTE);
  var customerCreateNoteAction = getApplicationAvailableAction(ApplicationActionName.CREATE_CUSTOMER_NOTE);
  return function canCreateBulkNote(permissions, noteType) {
    if (featureFlags['application_apr_notes']) {
      var _adminCreateNoteActio, _customerCreateNoteAc;
      return noteType === 'admin' ? !!(adminCreateNoteAction !== null && adminCreateNoteAction !== void 0 && (_adminCreateNoteActio = adminCreateNoteAction.additionalInformation) !== null && _adminCreateNoteActio !== void 0 && _adminCreateNoteActio.bulkCreateAllowed) : !!(customerCreateNoteAction !== null && customerCreateNoteAction !== void 0 && (_customerCreateNoteAc = customerCreateNoteAction.additionalInformation) !== null && _customerCreateNoteAc !== void 0 && _customerCreateNoteAc.bulkCreateAllowed);
    } else {
      return permissions && permissions['bulk_create_public_note'];
    }
  };
}